import { render, staticRenderFns } from "./bargain.vue?vue&type=template&id=13973354&scoped=true"
import script from "./bargain.vue?vue&type=script&lang=js"
export * from "./bargain.vue?vue&type=script&lang=js"
import style0 from "./bargain.vue?vue&type=style&index=0&id=13973354&prod&lang=less"
import style1 from "./bargain.vue?vue&type=style&index=1&id=13973354&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13973354",
  null
  
)

export default component.exports